var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.395,
    height: 18.453,
    viewBox: "0 0 17.395 18.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check-solid-2",
    d: "M9.182.105a1.174,1.174,0,0,0-.971,0L1.388,3A2.25,2.25,0,0,0,0,5.073C.018,8.668,1.5,15.246,7.74,18.235a2.213,2.213,0,0,0,1.913,0c6.244-2.99,7.722-9.567,7.741-13.162A2.25,2.25,0,0,0,16.006,3Zm3.609,7.469L8.153,12.212a.866.866,0,0,1-1.228,0L4.605,9.893A.869.869,0,0,1,5.834,8.665l1.7,1.7L11.56,6.342A.869.869,0,0,1,12.788,7.57Z",
    transform: "translate(0)",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUser);
export default __webpack_public_path__ + "static/media/verifiedUser.949c9ac8c40224973171e9a89235d299.svg";
export { ForwardRef as ReactComponent };